// Imports
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs';
// UI Imports
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from "@mui/icons-material/Add";
import { Grid, Card, CardMedia, CardActions, CardContent, FormControlLabel, IconButton, ToggleButtonGroup, ToggleButton } from "@mui/material";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Tooltip from '@material-ui/core/Tooltip'
import Checkbox from "@mui/material/Checkbox"
import { withStyles } from '@material-ui/core'
import styles from './styles'

// App Imports
import { messageShow } from '../../common/api/actions'
import SectionPaper from '../../common/SectionPaper'
import BrandedLoading from '../../common/BrandedLoading'
import EmptyMessage from '../../common/EmptyMessage'
import Image from '../../common/Image'
import { list } from '../api/actions/query'
import { remove, publishToggle } from '../api/actions/mutation'
import routes, { getImageSource } from '../api/routes'
import { detail } from "../../setting/api/actions/query"
import { checkPermission } from "../../common/Sidebar/checkPermission";

// Component
class List extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      viewMode: null,
      permissions:{
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      }
    }
  }

  componentDidMount() {
    this.refresh()
    this.verifyPermissions();
    this.fetchSettings();
  }

  fetchSettings = async () => {
    const { detail } = this.props;
    try {
      const { data } = await detail({ vendorId: '' });
      if (data.success && data.data) {
        const viewMode = data.data.viewMode || 'grid';
        this.setState({ viewMode });
      }
    } catch (error) {
      console.error("Error fetching setting details:", error);
    }
  };

  refresh = () => {
    const { list } = this.props

    list()
  }

  verifyPermissions = async () =>{
      const modulePermissions =await checkPermission("store","banners");
      this.setState({permissions:{canView:modulePermissions.canView,canCreate:modulePermissions.canCreate,canEdit:modulePermissions.canEdit,canDelete:modulePermissions.canDelete}});
  }

  onPublishToggle = bannerId => async event => {
    const isPublished = event.target.checked

    let check = window.confirm(`Are you sure you want to ${isPublished ? 'publish' : 'unpublish'} this banner?`)

    if (check) {
      const { publishToggle, messageShow } = this.props

      try {
        const { data } = await publishToggle({ bannerId, isPublished })
        messageShow(data.message)

        if (data.success) {
          this.refresh();
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }

  onDelete = (bannerId) => async () => {
    let check = window.confirm('Are you sure you want to delete this banner?')

    if (check) {
      const { remove, list, messageShow } = this.props

      try {
        const { data } = await remove({ bannerId })

        messageShow(data.message)

        if (data.success) {
          list()
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }
  
  render() {
    const { banners: { isLoading, list }, classes } = this.props
    const { permissions, viewMode } = this.state;
    
    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Banners
          </Typography>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newView) => {
              if (newView !== null) this.setState({ viewMode: newView });
            }}
            size="small"
            sx={{ marginRight: 2 }}
          >
            <Tooltip title="Grid View" arrow>
              <ToggleButton value="grid">
                <ViewModuleIcon />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="List View" arrow>
              <ToggleButton value="list">
                <ViewListIcon />
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup>
          <Tooltip title="Create Banner" arrow>
            <Link to={routes.bannerCreate.path} >
              <Button disabled={!permissions.canCreate} size='big' color="primary" startIcon={<AddIcon />}></Button>
            </Link>
          </Tooltip>
        </Toolbar>

          { viewMode === null ? (
            <BrandedLoading />
          ) : isLoading ? (
            <BrandedLoading />
          ) : list.length === 0 ? (
            <SectionPaper>
              <EmptyMessage message={'You have not added any banners yet.'} />
            </SectionPaper>
          ) : viewMode === 'grid' ? (
            <div className={classes.root}>
              <Grid container spacing={3}>
                {list.map(({ _id, image, name, sort, type, updatedAt, isPublished, modifiedBy}) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={_id}>
                    <Card sx={{ maxWidth: 400,  cursor: permissions.canEdit ? "pointer" : "default" }} onClick={() => permissions.canEdit && this.props.history.push(`/banner/edit/${_id}`)}>
                      <CardMedia
                        component="img"
                        image={getImageSource(image)}
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = getImageSource();
                          e.target.style.maxHeight = '120px'; 
                        }}
                        style={{   
                          objectFit: 'contain',
                          width: '100%'
                        }}
                      />
                      <CardContent>
                        <Typography variant="h6">{name}</Typography>
                        <Typography variant="body2" color="textSecondary">{type}</Typography>
                        <Typography variant="body2" color="textSecondary">{sort}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          Updated: {dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')} 
                          {modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Tooltip title="Delete" arrow>
                          <IconButton color="error" onClick={(e) => { e.stopPropagation(); this.onDelete(_id)(); }} disabled={!permissions.canDelete}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isPublished}
                              onClick={(e) => e.stopPropagation()}
                              onChange={this.onPublishToggle(_id)}
                              disabled={!permissions.canEdit}
                            />
                          }
                          label="Published"
                        />
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </div>
          ) : (
              <SectionPaper>
                <Table padding={"normal"}>
                  <TableHead>
                    <TableRow>
                      <TableCell width={85}>Image</TableCell>
                      <TableCell width={150}>Name</TableCell>
                      <TableCell width={150}>Type</TableCell>
                      <TableCell width={100}>Sort</TableCell>
                      <TableCell width={200}>Updated</TableCell>
                      <TableCell width={80} align="center">Published</TableCell>
                      <TableCell width={180} align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {
                      list.map(({ _id, image, name, sort, type, updatedAt, isPublished, modifiedBy}) =>
                        <TableRow key={_id} disabled={!permissions.canView} onClick={() => { this.props.history.push(`/banner/edit/${_id}`)}} style={{ cursor: 'pointer' }} hover>
                          <TableCell>
                            <Link to={routes.bannerEdit.path(_id)}>
                              <Image
                                src={getImageSource(`${image}`)}
                                defaultSrc={getImageSource()}
                              />
                            </Link>
                          </TableCell>
                          <TableCell>{name}</TableCell>
                          <TableCell>{type}</TableCell>
                          <TableCell>{sort}</TableCell>
                          <TableCell>{dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}{modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}</TableCell>
                          <TableCell align="center">
                            <Checkbox
                              onClick={(e) => e.stopPropagation()}
                              checked={isPublished}
                              disabled={!permissions.canEdit}
                              onChange={this.onPublishToggle(_id)}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Delete" arrow>
                            <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onDelete(_id)();
                            }}
                            color="error"
                            disabled={!permissions.canDelete}
                          >
                            <DeleteIcon />
                          </Button>

                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )
                    }
                  </TableBody>
                </Table>
              </SectionPaper>
          )
        }
      </div>
    )
  }
}

// Component Properties
List.propTypes = {
  banners: PropTypes.object.isRequired,
  list: PropTypes.func.isRequired,
  publishToggle: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  detail: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

// Component State
function listState(state) {
  return {
    banners: state.banners
  }
}

export default connect(listState, { list, publishToggle, remove, messageShow, detail })(withStyles(styles)(List))
